import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  justify-content: center;
  text-align: center;
  padding: 24px;

  .text {
    color: ${colors.white};
    font-size: 18px;
    font-weight: 600;
    margin: 16px 0 0 0; 
  }
`;
